export const DOCUMENT_PAYWALL_FLAG = {
  name: 'tomorrow_paywall_for_document_completion',
  variants: {
    on: 'on',
    off: 'off',
  },
};
